import { TranslateService } from '@ngx-translate/core';
import { Component, Input, OnInit, SimpleChanges } from '@angular/core';
declare const TradingView: any;

@Component({
  selector: 'app-trading-view-chart',
  templateUrl: './trading-view-chart.component.html',
  styleUrls: ['./trading-view-chart.component.scss']
})
export class TradingViewChartComponent {

  @Input() reuters;
  @Input() symbolCode;
  @Input() companyName;
  @Input() isLinked;
  isDarkTheme: boolean;

  constructor(private translate: TranslateService) { }

  ngOnInit(){
    this.isDarkTheme =
      localStorage.getItem("darktheme") == "dark" ? true : false;
  }

  ngAfterViewInit() {
    if (!this.isLinked) {
      this.initChart();
    }
  }

  initChart() {
    new TradingView.widget({
      width: "100%",
      height: "100%",
      symbol: "EGX:" + this.symbolCode,
      interval: "D",
      timezone: "Africa/Cairo",
      theme: this.isDarkTheme?"Dark":"Light",
      style: "1",
      locale: this.translate.currentLang == "ar" ? "ar_AE" : "en",
      toolbar_bg: "#f1f3f6",
      enable_publishing: false,
      withdateranges: false,
      // range: "ytd",
      hide_side_toolbar: true,
      allow_symbol_change: false,
      show_popup_button: false,
      autosize: true,
      hide_legend: true,
      save_image: false,
      no_referral_id: true,
      container_id: this.symbolCode,
    });
  }

  ngOnChanges(changes: SimpleChanges) {
    if (this.isLinked && changes.reuters.currentValue != changes.reuters.previousValue) {
      this.symbolCode = changes.symbolCode.currentValue;
      setTimeout(() => {
        this.initChart();
      }, 200);


    }
  }

  get symbol() {
    if (this.symbolCode)
      return this.symbolCode;
  }
}
